import type { ReactNode } from "react";
import { displayName } from "../emulator/saves";
import ConsoleIcon from "./ConsoleIcon";
import { SYSTEM_ORDER, type System } from "./localLibrary";
import { useCover } from "./useCover";
import { Icon } from "@jkast90/kast-common/ui";

/**
 * A game as the library lists it: cover, console and name, a line under
 * it, and where it lives. A row to pick (the library page) is a button; one
 * with `actions` beside it (the admin page) is not.
 */
export default function GameRow({
  name,
  system,
  meta,
  where,
  selected = false,
  onSelect,
  actions,
}: {
  name: string;
  system: string | null;
  meta: ReactNode;
  where?: ReactNode;
  selected?: boolean;
  onSelect?: () => void;
  actions?: ReactNode;
}) {
  const cover = useCover(name);
  const body = (
    <>
      <span className="library-thumb">{cover ? <img src={cover} alt="" loading="lazy" /> : <Icon name="videogame_asset" size={20} className="icon" />}</span>
      <span className="library-item-text">
        <span className="library-item-name">
          {system && SYSTEM_ORDER.includes(system as System) && <ConsoleIcon system={system as System} named />}
          {displayName(name)}
        </span>
        <span className="muted small">{meta || " "}</span>
      </span>
      {where && (
        <span className="library-where" aria-hidden="true">
          {where}
        </span>
      )}
    </>
  );
  return (
    <li>
      {onSelect ? (
        <button type="button" className={`library-item${selected ? " selected" : ""}`} onClick={onSelect} aria-current={selected}>
          {body}
        </button>
      ) : (
        <div className="library-item static">
          {body}
          {actions && <span className="btn-group library-actions">{actions}</span>}
        </div>
      )}
    </li>
  );
}
